exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".slide-enter-active[data-v-d575f0ba]{transition-duration:.3s;transition-timing-function:ease-in}.slide-leave-active[data-v-d575f0ba]{transition-duration:.3s;transition-timing-function:cubic-bezier(0,1,.5,1)}.slide-enter-to[data-v-d575f0ba],.slide-leave[data-v-d575f0ba]{max-height:100px;overflow:hidden}.slide-enter[data-v-d575f0ba],.slide-leave-to[data-v-d575f0ba]{overflow:hidden;max-height:0}", ""]);

// exports
